import type { PropsWithChildren, ReactNode, SVGProps } from "react";

import { AlertTriangleIcon, CircleCheckOverIcon, ExclamationCircleIcon } from "../../components";
import { cn } from "../../utils";
import { useAlertRootContext } from "./context";
import { alertLayoutStyle } from "./styles";

export type AlertIconLayoutProps = PropsWithChildren<{
  Icon?: (props: SVGProps<SVGSVGElement>) => ReactNode;
  className?: string;
  title: ReactNode;
}>;

const IconLayout = ({ Icon, children, className, title }: AlertIconLayoutProps) => {
  const { type, orientation } = useAlertRootContext();

  const getIcon = () => {
    switch (type) {
      case "primary":
      case "secondary":
      case "error":
        return ExclamationCircleIcon;
      case "warning":
        return AlertTriangleIcon;
      case "success":
        return CircleCheckOverIcon;
      default:
        return null;
    }
  };

  const IconToUse = Icon || getIcon();

  return (
    <div className={cn(alertLayoutStyle({ orientation }), "items-start gap-3", className)}>
      {IconToUse && <IconToUse className="h-5 w-5 shrink-0" />}
      <div className="flex flex-1 flex-col gap-1">
        <h3 className="mr-4 font-semibold">{title}</h3>
        {children}
      </div>
    </div>
  );
};

export default IconLayout;
